/**
 * @generated SignedSource<<6fe209da6a9c61698a3ee523d3b6b589>>
 * @relayHash 7109e2a0122fe41fae28aba711fb3d51
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a12ba560eb94d6e44a75a30daaf4d0f03f2ca672aa75b888dd1555325eb72f17

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiFormsQuery } from './uiFormsQuery.graphql';

const node: PreloadableConcreteRequest<uiFormsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a12ba560eb94d6e44a75a30daaf4d0f03f2ca672aa75b888dd1555325eb72f17",
    "metadata": {},
    "name": "uiFormsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
